import { DetailModel } from '@app/src/views/CipReport/report/models/Detail';
import { DetailService } from '@app/src/views/CipReport/report/models/DetailService';
import { PAYMENT_TYPE } from './constants';

export const hydrateDetail = (data: DetailService): DetailModel => {
  const formatDataEmpty = (data) => {
    return !!data ? data : '- - - - -';
  };

  let detail = data.data.map((detail) => {
    return {
      cip: detail.cip,
      idState: detail.stateId,
      state: detail.state,
      generationDate: formatDataEmpty(detail.dateGeneration),
      expirationDate: formatDataEmpty(detail.dateExpiring),
      paymentDate: formatDataEmpty(detail.datePay),
      currency: detail.currency,
      amount: detail.amount,
      documentNumber: formatDataEmpty(detail.documentNumber),
      name: formatDataEmpty(detail.name),
      lastName: formatDataEmpty(detail.lastName),
      operatorName: detail.operatorName,
      operatorLastName: detail.operatorLastName,
      phone: formatDataEmpty(detail.cellPhone),
      email: detail.email,
      requestNumber: detail.requestNumber,
      paymentType: detail.paymentType,
      paymentTypeName: PAYMENT_TYPE[detail.paymentType],
      extra: formatDataEmpty(detail.details)
    }
  });

  let page = {
    total: 0,
    current: 0,
    totalRow: 0
  };

  page.total = data.metadata.totalPage;
  page.current = data.metadata.page;
  page.totalRow = data.metadata.totalRow;

  const dataHydrate: DetailModel = {
    code: data.code,
    message: data.message,
    detail: detail,
    page: page
  };

  return dataHydrate;
};
